import {EntityLogoRequestParams} from "../../../../infrastructure/models/params/entity-logo-request-params";
import {LanguageViewModel} from "./language.view-model";

export class LanguageLogoParams extends EntityLogoRequestParams {
  constructor(params: LanguageLogoParams, entity: LanguageViewModel) {
    super({...params, resourceName: `Website/Languages` }, entity);

    this.fallbackResourceName = 'Countries';
    this.fallbackResourceId = 1;
  }
}
